import styled from "styled-components";

export const Container = styled.nav`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-right: auto;
  margin-left: 6vw;
  margin-top: 1vh;
`;

export const Item = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 15px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #5f6368;
  gap: 8px;
  span {
    margin-top: 2px;
  }

  /* Estilos do ícone */
  & > svg {
    color: #5f6368;
    transition: color 0.2s ease-in-out;
  }

  /* Estilos quando o item está ativo */
  ${(props) =>
    props.$isActive &&
    `
    background-color: #E8F0FE;
    color: #1967D2;

    & > svg {
      color: #1967D2;
    }
  `}

  /* Efeito de hover, apenas se não estiver ativo */
  &:hover {
    ${(props) =>
      !props.$isActive &&
      `
      background-color: #f1f3f4;
    `}
  }
`;
